/* global Cypress */

export const KERALA_PUBLIC_LOGO =
  'https://storage.googleapis.com/kerala-public-assets/Kerala%20Ventures%20Square.png';

export const MENU_ITEMS = [
  {
    title: 'Profil',
    routeName: '/profile',
  }, {
    title: 'Opportunités',
    routeName: '/opportunities',
  }, {
    title: 'Mes investissements',
    routeName: '/investments',
  },
  {
    title: 'Fonctionnement du club',
    href: 'https://www.notion.so/keralaventures/Le-fonctionnement-du-Kerala-Club-e60485b28fa94c559cf26444f8988789',
  },
];

let apiUrl;
if (typeof Cypress !== 'undefined') {
  apiUrl = process.env.VUE_APP_CYPRESS_API_URL;
} else {
  apiUrl = process.env.VUE_APP_API_URL;
}

export const API_URL = apiUrl;

export const MARITAL_STATUS_ITEMS = [{
  id: 1,
  title: 'Marié(e)',
}, {
  id: 2,
  title: 'Pacsé(e)',
}, {
  id: 3,
  title: 'Célibataire',
}];

export const MARRIAGE_TYPE_ITEMS = [{
  id: 1,
  title: 'Communauté réduite aux acquêts',
}, {
  id: 2,
  title: 'Séparation des biens',
}, {
  id: 3,
  title: 'Communauté universelle',
}, {
  id: 4,
  title: 'Participation aux acquêts',
}];

export const HAS_CHILDREN_ITEMS = [{
  id: 1,
  title: 'Aucun',
}, {
  id: 2,
  title: 'Une ou plusieurs',
}];

export const PPE_ITEMS = [{
  id: 1,
  title: 'Oui',
  value: true,
}, {
  id: 2,
  title: 'Non',
  value: false,
}];
